import { IConfig, IConfiguration } from '@microsoft/applicationinsights-web';

export const AppInsightsClickPluginConfig = {
    autoCapture: true,
};

/**
 * Domains excluded from receiving Application Insights correlation headers.
 * These headers (e.g., request-id, traceparent) can cause CORS errors if
 * the target server doesn't include them in Access-Control-Allow-Headers.
 */
export const CORRELATION_HEADER_EXCLUDED_DOMAINS = [
    'shs.login.siemens-healthineers.com',
    'login.siemens-healthineers.com',
    'login.microsoftonline.com',
    'login.windows.net',
];

export const AppInsightsAngularPluginConfig: IConfiguration & IConfig = {
    enableAutoRouteTracking: true,
    enableAjaxPerfTracking: true,
    enableAjaxErrorStatusText: true,

    enableCorsCorrelation: true,
    disableCorrelationHeaders: false,
    correlationHeaderExcludedDomains: CORRELATION_HEADER_EXCLUDED_DOMAINS,
    enableRequestHeaderTracking: false,
    enableResponseHeaderTracking: false,

    disableExceptionTracking: false,
    samplingPercentage: 100,
    enableUnhandledPromiseRejectionTracking: true,
};

const REDACTION_PATTERNS: Array<[RegExp, string]> = [
    [/\bBearer\s+[A-Za-z0-9-_]+\.[A-Za-z0-9-_]+\.[A-Za-z0-9-_]+\b/, '[REDACTED_BEARER]'],
    [/\b([a-zA-Z0-9._%+-]+)@(([a-zA-Z0-9-]+\.)+[a-zA-Z]{2,})\b/gu, '[REDACTED_EMAIL]'], // mails
];

export function redactString(text: string): unknown {
    if (typeof text !== 'string') {
        return text;
    }
    let result = text;
    for (const p of REDACTION_PATTERNS) {
        result = result.replace(p[0], p[1]);
    }
    return result;
}
